import React from 'react'
import {Box, useBreakpointValue, Flex} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import Slider from '../../components/cms/slider'
import ModuleContainer from '../../components/cms/module-container'
import Teaser from '../../components/cms/teaser'
import Heading from '../../components/cms/heading'
import Copy from '../../components/cms/copy'
import {parseAspectRatio} from '../../utils/utils'

function Carousel({
    alignment,
    headingLevel,
    aspectRatio,
    heading,
    copy,
    tiles,
    anchor,
    background
}) {
    return (
        <ModuleContainer
            anchor={anchor}
            background={background}
            display="flex"
            flexDirection="column"
            align={'start'}
            pt="spacing-128"
            pb={{base: 'spacing-40', s: 'spacing-128'}}
            heading={heading}
        >
            <Flex gap="spacing-16" alignment={alignment} flexDirection="column">
                <Heading {...heading} headingLevel={headingLevel} alignment={alignment}></Heading>

                <Copy {...copy} alignment={alignment} />
            </Flex>

            <Box pt="spacing-40">
                <Slider itemsPerSlide={useBreakpointValue({base: 1, s: 3})} gap={4}>
                    {tiles.map((item, index) => (
                        <Box key={index}>
                            <Teaser
                                headline={item.headline}
                                asset={item.asset}
                                assetFlip={item.assetFlip}
                                aspectRatio={parseAspectRatio(aspectRatio)}
                                copy={item.copy}
                                cta={item.cta}
                            ></Teaser>
                        </Box>
                    ))}
                </Slider>
            </Box>
        </ModuleContainer>
    )
}

Carousel.propTypes = {
    alignment: PropTypes.string,
    headingLevel: PropTypes.string,
    aspectRatio: PropTypes.string,
    heading: PropTypes.object,
    copy: PropTypes.object,
    tiles: PropTypes.array,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    anchor: PropTypes.string
}

export default Carousel
